import React from 'react';
import {connect} from 'react-redux';
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import css from './LayersPanel.module.css';
import * as filterActions from '../../../../store/filterSlice';
import Checkbox from "@material-ui/core/Checkbox";
import {raidLevelMap} from "../../../../utils";

const RaidControls = (props) => {
	const onChangeRaidExFilter = (event) => {
		props.toggleFeature('raidExFilter');
	};

	const toggleRaidLevel = (level) => {
		props.toggleFeature('raidLevel' + level);
	};

	const raidLevels = [];

	for( const level of raidLevelMap)
		raidLevels.push((
				<FormControlLabel key={'raidLevel-' + level.level} control={(
					<Checkbox
						checked={props['raidLevel' + level.level]}
						onChange={() => toggleRaidLevel(level.level)}
					/>
				)} label={level.name} labelPlacement='top' />
		));

	return (
		<div className={css.Panel}>
			<div className={css.Title}>Raids</div>

			<FormControl className={css.FormElement}>
				<div>Show Raid Levels:</div>
				<div className={css.RaidLevels}>
					{raidLevels}
				</div>
			</FormControl>

			<FormControl className={css.FormElement}>
				<FormControlLabel control={(
					<Checkbox
						checked={props.raidExFilter}
						onChange={onChangeRaidExFilter}
					/>
				)} label='Only EX-Eligible Raids' />
			</FormControl>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		raidLevel1: state.filter.raidLevel1,
		raidLevel2: state.filter.raidLevel2,
		raidLevel3: state.filter.raidLevel3,
		raidLevel4: state.filter.raidLevel4,
		raidLevel5: state.filter.raidLevel5,
		raidLevel6: state.filter.raidLevel6,
		raidExFilter: state.filter.raidExFilter,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		toggleFeature: (val) => dispatch(filterActions.toggleFeature(val)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(RaidControls);